var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batchDisbursementModal" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.$t("send_pagements.new_batch_small_disbursement"),
            "close-on-click-modal": false,
            width: "1100px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "step" }, [
            _c(
              "div",
              {
                staticClass: "step-item",
                staticStyle: { "margin-right": "24px" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "section-title",
                    staticStyle: { color: "#F67C7C" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("send_pagements.first_things_first")) +
                        " "
                    ),
                  ]
                ),
                _c("div", { staticClass: "batch-tip" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("tips.download_and_fill_template_batch_payments")
                      ) +
                      " "
                  ),
                ]),
                _c("div", { staticClass: "download-container" }, [
                  _c(
                    "div",
                    { staticClass: "download-middle" },
                    [
                      _c("div", { staticClass: "download-title-text" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "send_pagements.excel_worksheet_template_excel"
                              )
                            )
                        ),
                      ]),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.onClickDownloadBtn },
                        },
                        [
                          _c("svg-icon", {
                            attrs: { "icon-class": "download" },
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("send_pagements.download_template"))
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "download-title-text-2" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "tips.latest_template_updated_supported_payment_channels"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "batch-tip-2" }, [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("send_pagements.submit_batch_ease")) +
                      " "
                  ),
                ]),
                _c("div", [
                  _c("div", { staticClass: "batch-tip-content" }, [
                    _c("span", [_vm._v("1. ")]),
                    _c("div", [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("send_pagements.step_1_title")) +
                            " "
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("send_pagements.step_1_content")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "batch-tip-content" }, [
                    _c("span", [_vm._v("2. ")]),
                    _c("div", [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("send_pagements.step_2_title")) +
                            " "
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("send_pagements.step_2_content")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "batch-tip-content" }, [
                    _c("span", [_vm._v("3. ")]),
                    _c("div", [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("send_pagements.step_3_title")) +
                            " "
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("send_pagements.step_3_content")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "batch-tip-content" }, [
                    _c("span", [_vm._v("4. ")]),
                    _c("div", [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("send_pagements.step_4_title")) +
                            " "
                        ),
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("send_pagements.step_4_content")) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
            _c(
              "div",
              { staticClass: "step-item" },
              [
                _c(
                  "div",
                  {
                    staticClass: "section-title",
                    staticStyle: { color: "#364250" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("tips.upload_filled_excel_worksheet_template")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("div", { staticClass: "batch-tip" }, [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t(
                          "tips.upload_filled_excel_using_template_batch_payments"
                        )
                      ) +
                      " "
                  ),
                ]),
                _c(
                  "UploadExcelFile",
                  _vm._g(
                    {
                      attrs: { "reference-batch-no": _vm.reference_batch_no },
                      on: { templateFileSuccess: _vm.templateFileSuccess },
                    },
                    _vm.$listeners
                  )
                ),
                _c(
                  "div",
                  {
                    staticClass: "batch-tip-2",
                    staticStyle: { color: "#F67C7C" },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("tips.following_three_situations_cause_fail")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c("div", [
                  _c("div", { staticClass: "batch-tip-content" }, [
                    _c("span", [_vm._v("1. ")]),
                    _c("div", [
                      _vm._v(
                        " " + _vm._s(_vm.$t("tips.spaces_in_the_amount")) + " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "batch-tip-content" }, [
                    _c("span", [_vm._v("2. ")]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("tips.spaces_in_the_email_address")) +
                          " "
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "batch-tip-content" }, [
                    _c("span", [_vm._v("3. ")]),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$store.getters.curCountry.country_code === "ID"
                              ? _vm.$t(
                                  "tips.wallet_account_number_not_start_with_08"
                                )
                              : _vm.$store.getters.curCountry.country_code ===
                                "TH"
                              ? _vm.$t("tips.wallet_account_number_rule")
                              : _vm.$t(
                                  "tips.wallet_account_number_not_start_with_09"
                                )
                          ) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }